/**
 * @prettier
 */
import React from "react"
import PropTypes from "prop-types"

const Copy = ({ className, width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 16"
        className={className}
        width={width}
        height={height}
        aria-hidden="true"
        focusable="false"
    >
        <g transform='translate(2, -1)'>
            <path 
                fill='#ffffff'
                fillRule='evenodd'
                d='M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z'></path>
        </g>
    </svg>
)

Copy.propTypes = {
    className: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
}

Copy.defaultProps = {
    className: null,
    width: 15,
    height: 16,
}

export default Copy